import '@angular/compiler';
import {
    enableProdMode
} from '@angular/core';
import './polyfills';
import {
    AppModule
} from './app/main.module';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { UIView } from '@uirouter/angular';

if (environment.production) {
    enableProdMode();
}

// A prerendered page (Chrome starts one for a URL typed in the omnibox) gets a temporary
// sessionStorage that is swapped for the tab's real one on activation. Bootstrapping before then
// writes the localStorage -> sessionStorage auth copy into storage that is about to be discarded,
// and the shell waits forever for a profile it never requests. Start only once activated.
const activated = (document as any).prerendering
    ? new Promise<void>((resolve) => document.addEventListener('prerenderingchange', () => resolve(), {once: true}))
    : Promise.resolve();

activated.then(() => bootstrapApplication(UIView, {
    providers: [
        importProvidersFrom(AppModule)
    ]
})).catch((err) => console.error(err));
